__turbopack_context__.v({
  "aria-live-text": "profile-photo-cropper-module-scss-module__SCPrsq__aria-live-text",
  "cropper": "profile-photo-cropper-module-scss-module__SCPrsq__cropper",
  "cropper__image": "profile-photo-cropper-module-scss-module__SCPrsq__cropper__image",
  "wrapper": "profile-photo-cropper-module-scss-module__SCPrsq__wrapper",
});
